import axios from 'axios'
import Vue from 'vue'

// const URL = 'https://sundrymarkets.website/api/'
const URL = 'https://sundryfoods.website/api/'
// const URL = 'http://127.0.0.1:8000/api/'

export default{
	name: 'Request',
	url: URL.substring(0, URL.indexOf('/api')),

	makeGetRequest: (request)=>{

		Vue.prototype.$swal.close()

		var loading_html = '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>'

        Vue.prototype.$swal.fire({
            title: "", 
            html: loading_html,  
            showConfirmButton: false,
            showCancelButton: false,
            allowOutsideClick: false
        })

		var request_urls = {
			ListApplicants: 'getapplicant',
			GetCBT: 'cbt',
			InterviewVideo: 'interviewvideo',
			InterviewInformation: 'applicant_interviewinfo',
			GetOfferLetter: 'viewjoboffer',
			GetJobs: 'allopenings'
		}

		var c_str = "company_id=" + 1 + "&companyid=" + 1
        if (request.params !== undefined) {
            var obj = request.params
            var str = Object.keys(obj).map((key) => { return key + '=' + obj[key] }).join('&')
            var request_url = URL + request_urls[request.what] + "?" + str + "&" + c_str
        } else {
            if (request.id !== undefined) {
                var request_url = URL + request_urls[request.what] + "/" + request.id + "?" + c_str
            } else {
                var request_url = URL + request_urls[request.what] + "?" + c_str
            }
        }

		console.log('%cSending get request to: ' + '%c' + request_url, 'color:#00ff00;font-size:14px;background:#000;','color:#ff0000;font-size:14px;background:#000;')

		return new Promise((resolve, reject)=>{
			axios.get(request_url)
				.then((response)=>{

					//console.log(response)
					Vue.prototype.$swal.close()

					if(response.data.status == 'True' || response.data.status == true || response.data.status == 'true'){

						var response = {
							data: response.data.data,
							type: request.what,
							status: 'true',
							url: URL
						}

						resolve(response)

					} else {
						reject(response.data)
					}
				})
				.catch((err)=>{
					Vue.prototype.$swal.close()
					reject(err)
				})
		})
	},

	makePostRequest: (request)=>{

		Vue.prototype.$swal.close()

		var loading_html = '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>'

        Vue.prototype.$swal.fire({
            title: "", 
            html: loading_html,  
            showConfirmButton: false,
            showCancelButton: false,
            allowOutsideClick: false
        })

		var request_urls = {
			login: 'applicantlogin',
			SubmitCbt: 'cbtanswers',
			RespondToOffer: 'respondtoffer',
			ChangePassword: 'changeapplicantpass',
			CheckIfApplicantHasTakenTest: 'checkiftesttaken'
		}

		if (request.params !== undefined) {
            var obj = request.params
            var str = Object.keys(obj).map((key) => { return key + '=' + obj[key] }).join('&')
            var request_url = URL + request_urls[request.what] + "?" + str
        } else {
            var request_url = URL + request_urls[request.what]
        }

        if (request.url == undefined) {
            var request_url = URL + request_urls[request.what]
        } else {
            var request_url = request.url
        }

        if (request.headers !== undefined) {
            var config = {
                headers: request.headers
            }

        } else {
            var config = {

            }
        }
        var data = (request.data !== undefined) ? request.data : {}
        data.company_id = 1
        data.companyid = 1
        console.log('%cSending post request to: ' + request_url, 'color:#00ff00;font-size:14px;background:#000;')
        console.log(data)
		return new Promise((resolve, reject)=>{
			axios.post(request_url, data, config)
				.then((response)=>{

					Vue.prototype.$swal.close()

					if(response.data.status == 'True' || response.data.status == true || response.data.status == 'true'){

						response = {
							data: response.data,
							type: request.what,
							status: 'true',
							url: URL
						}

						resolve(response)

					} else {
						reject(response)
					}
				})
				.catch((err)=>{
					Vue.prototype.$swal.close()
					reject(err)
				})
		})
			
	}
}